import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { usePlayerContext } from '../../Context';
import { Events, State, StateChangedEvents } from '../../../types/player';
import { Error as ErrorType } from '../../../types/error';

const Error = () => {
  const { sdk } = usePlayerContext();
  const [error, setError] = useState('');
  const { t } = useTranslation();
  let listeners: (() => void)[] = [];

  useEffect(() => {
    listeners.push(sdk.on(Events.ERROR, (error: ErrorType) => {
      let hook = sdk.options().getLocale()?.hooks?.errorLabel;
      if (hook && hook(error) !== false) {
        const customLabel = hook(error);        
        setError(customLabel);
      }
      else
        setError(t(error.message));
    }));

    listeners.push(sdk.on(Events.STATE_CHANGED, (event: StateChangedEvents) => {
      if(event.newState !== State.ERROR) setError('');
    }));
    
    return () => {
      listeners.forEach((listener) => listener());
    }

  }, []);

  const prefix = sdk.getClassNamePrefix();
  if (!error) return null;
  return (
    <div className={`${prefix}-player-notification-error`}>
      <div className={`${prefix}-player-notification-error-message`}>
        {error}
      </div>
    </div>
  );
};

export default Error;
